import { render, staticRenderFns } from "./CourseDetailView.vue?vue&type=template&id=39b43a48"
import script from "./CourseDetailView.vue?vue&type=script&lang=js"
export * from "./CourseDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports